import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from '../../api/services/project.services';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { MarketService } from '../../api/services/market.service';
import { UserService } from '../../api/services/user.service';
import { AuthService } from '../../api/services/auth.service';
import { Worksheet } from '../../api/models/worksheet';
import { BomLine } from '../../api/models/bom-line';
import { Market } from '../../api/models/market-model';
import { User } from '../../api/models/user-model';
import { TasksService } from '../../api/services/tasks.service';

export class WarrantyFormModel {
  tesscoAccountNumber: string;
  companyName: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  originalSalesOrderNumber: string;
  tesscoPartNumber: string;
  quantity: string;
  serialNumber: string;
  replacementNeeded: boolean;
  description: string;

  constructor(market?: Market, user?: User, worksheet?: Worksheet) {
    this.tesscoAccountNumber = market.accountNumber;
    this.companyName = market.customerName;
    this.firstName = user["First Name"];
    this.lastName = user["Last Name"];
    this.phone = user["SMS Phone Number"];
    this.email = user["Email Address"];
    this.originalSalesOrderNumber = worksheet && worksheet.shipmentDetails && worksheet.shipmentDetails.length ? 
    worksheet.shipmentDetails[0].orderHeaders[0].salesOrderNumber
    : '';
  }
}

class WarrantyProduct {
  partNumber: string;
  qty: number;

  constructor(data: any = {}) {
    this.partNumber = data.partNumber || '';
    this.qty = data.qty || 0;
  }
}

@Component({
  selector: 'app-warranty-claim',
  templateUrl: './warranty-claim.component.html',
  styleUrls: ['./warranty-claim.component.scss']
})
export class WarrantyClaimComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private marketService: MarketService,
    private userService: UserService,
    private authService: AuthService,
    private taskService: TasksService
    ) { }

  additionalProducts = [];

  loading = true;
  index = 1;

  selectedProduct: WarrantyProduct = new WarrantyProduct();
  products: WarrantyProduct[] = [];

  worksheet: Worksheet;

  warrantyForm: FormGroup;
  warrantyInfo: WarrantyFormModel;
  errorMessage: string[] = [];

  addProduct() {
    this.additionalProducts.push({index: this.index += 1, body: ''});
  }

  mapToProduct(line: BomLine) {
    return {partNumber: line.partNumber, qty: line.quantity};
  }

  ngOnInit() {
    this.activatedRoute
      .params.map(p => p.id)
      .subscribe(id => {
        this.projectService.getWorksheet(id).subscribe(w => {
          if (this.userService.isMarketPermittedForCurrentUser(w.project.marketId)) {
            this.worksheet = w;
            forkJoin(
              this.marketService.getMarket(this.worksheet.project.marketId),
              this.userService.findUserById(this.authService.getUserId()),
              this.projectService.getBomLines(this.worksheet.bomId)
            ).subscribe(result => {
              const market = result[0];
              const user = result[1];
              this.products = result[2].map(line => this.mapToProduct(line));

              this.warrantyInfo = new WarrantyFormModel(market, user, this.worksheet);
              this.warrantyForm = this.formBuilder.group({
                tesscoAccountNumber: [this.warrantyInfo.tesscoAccountNumber, Validators.required],
                companyName: [this.warrantyInfo.companyName],
                firstName: [this.warrantyInfo.firstName, Validators.required],
                lastName: [this.warrantyInfo.lastName, Validators.required],
                phone: [this.warrantyInfo.phone, Validators.required],
                email: [this.warrantyInfo.email, Validators.email],
                originalSalesOrderNumber: [this.warrantyInfo.originalSalesOrderNumber, Validators.required],
                tesscoPartNumber: [this.warrantyInfo.tesscoPartNumber, Validators.required],
                quantity: [this.selectedProduct.qty, Validators.required],
                serialNumber: [this.warrantyInfo.serialNumber],
                replacementNeeded: [this.warrantyInfo.replacementNeeded],
                description: [this.warrantyInfo.description, Validators.required]
              });
              this.loading = false;
              
            }); 
          } else {
            this.loading = false;
            this.worksheet = null;
            this.errorMessage.push("You don't have permission to view this page!!!");
          }
        });
      });
  }

  setProduct(productNumber: string) {
    this.selectedProduct = this.products.find(p => p.partNumber === productNumber);
    this.warrantyForm.get('tesscoPartNumber').setValue(this.selectedProduct.partNumber);
    this.warrantyForm.get('quantity').setValue(this.selectedProduct.qty);
  }

  submit() {
    this.additionalProducts.forEach(product => this.warrantyForm.addControl(product.index, this.formBuilder.control(product.body)));
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/warranty-claim/warranty-claim.component.ts